import { colors } from 'modules/app/styles'
import styled from 'styled-components'

// Templates Modal
export const TemplatesList = styled.ul`
  padding: 8px 24px;
  margin-top: 12px;
  li {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    cursor: pointer;
    position: relative;
    &:last-of-type {
      margin-bottom: 0;
    }
    &:hover,
    &.active {
      color: ${colors['main-blue']};
      font-weight: 600;
    }
    .title-div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 2rem;
      overflow: hidden;
      span.icon {
        width: 20px;
        text-align: center;
        margin-right: 4px;
      }
      span.template-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .more-button-dropdown {
      position: absolute;
      right: 8px;
      button.toggle {
        width: 18px;
        height: 18px;
        svg {
          width: 14px;
          height: 14px;
        }
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }

    &:hover .more-button-dropdown button.toggle {
      display: flex;
    }
  }
`

// Response packs
export const ResponsePacks = styled.div`
  height: 80vh;
  overflow: hidden;
  display: flex;
  .categories {
    height: 100%;
    border-right: 1px solid ${colors['light-blue-200']};
    overflow: hidden;

    position: absolute;
    left: 0;
    width: 100%;
    z-index: 1;
    background: #fff;
    transform: translateX(-100%);
    transition: 0.2s ease-in;
    &.active {
      transform: translateX(0);
    }
    @media (min-width: 576px) {
      position: unset;
      left: unset;
      z-index: 1;
      width: 320px;
      transform: none;
    }
    .title {
      margin: 24px;
    }
    .category-items {
      height: calc(100% - 92px);
      overflow: auto;
      .category-name {
        cursor: pointer;
        padding: 12px 24px;
        border-bottom: 1px solid ${colors['light-blue-200']};
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .expandButton {
          display: flex;
          align-items: center;
          .count {
            width: 18px;
            height: 18px;
            border-radius: 18px;
            line-height: 18px;
            background: ${colors['light-blue-200']};
            text-align: center;
          }
          svg {
            fill: ${colors['main-text']};
            pointer-events: none;
          }
          .deep-link {
            width: 20px;
            height: 20px;
            border-radius: 10px;
            align-items: center;
            justify-content: center;
            display: none;
            &.copied {
              background: ${colors['green']} !important;
              svg {
                fill: #fff !important;
              }
            }
          }
        }
        &:hover,
        &.active {
          color: ${colors['main-blue']};
          .expandButton {
            svg {
              fill: ${colors['main-blue']};
            }
            .deep-link {
              display: flex;
              svg {
                fill: ${colors['main-text']};
              }
              &:hover {
                background: ${colors['light-blue-200']};
              }
            }
          }
        }
      }
    }
  }
  .templates {
    background: ${colors['gray-200']};
    padding: 24px 12px 0;
    height: 100%;
    overflow: hidden;
    flex: 1;
    .template-items {
      height: calc(100% - 33px);
      overflow: auto;
      .template {
        border: 1px solid ${colors['light-blue-200']};
        background: #fff;
        padding: 12px;
        margin-bottom: 4px;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        .response-title {
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 8px;
          line-height: 1.4;
        }
        .response-content {
          line-height: 1.5;
        }
        &:hover {
          border: 1px solid ${colors['main-blue']};
          .select-category-dropdown {
            display: block;
          }
        }

        .select-category-dropdown {
          position: absolute;
          right: 8px;
          top: 8px;
          width: auto;
          display: none;
          .dropdown-menu {
            width: 300px;
          }
        }
      }
    }
  }
`
export const TemplatePreview = styled.div`
  padding: 0 5px;
  .response-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2;
  }

  .select-category-dropdown {
    width: auto;
    .dropdown-menu {
      width: 300px;
    }
  }
`

export const ResponsePackToastMessage = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  padding: 7px;
  background: ${colors['main-blue']};
  display: flex;
  align-items: center;
  &.error {
    background: ${colors.red};
  }
  svg {
    width: 20px;
    height: 20px;
    path {
      fill: #fff;
    }
  }

  transform: translateY(100%);
  transition: transform 0.2s ease-in;
  &.active {
    transform: translateY(0);
  }
`
